<template>
  <div>
    <r-title class="title">{{ $t('create.password') }}</r-title>
    <p class="error">{{ error }}</p>
    <a-form class="form" :form="form" @submit.prevent="handleSubmit">
      <create-password-input v-model="password" class="create-password-input" />
      <a-button type="primary" html-type="submit" :disabled="disabled" :loading="loading">
        {{
        $t('save')
        }}
      </a-button>
    </a-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import RTitle from '@/components/common/Title.vue';
import CreatePasswordInput from '@/components/common/CreatePasswordInput.vue';

import { CREATE_PASSWORD } from '@/store/session/actionTypes';
import { ROUTER_PATHS } from '@/router/constants';

export default {
  props: ['code'],
  components: {
    RTitle,
    CreatePasswordInput,
  },
  data() {
    return {
      password: '',
      error: '',
      disabled: true,
      loading: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'createPassword' });
  },
  provide() {
    return {
      form: this.form,
    };
  },
  methods: {
    handleSubmit() {
      this.send(this.code, this.password);
    },
    ...mapActions({
      createPassword: CREATE_PASSWORD,
    }),
    async send(code, newPassword) {
      this.loading = true;

      try {
        await this.createPassword({ code, newPassword });
        this.$router.push(ROUTER_PATHS.LOGIN);
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    password() {
      this.form.validateFields((err) => {
        this.disabled = Boolean(err);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
.title {
  text-align: center;
}
.form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.error {
  color: $red;
  text-align: center;
}
.create-password-input {
  .password-inputs {
    display: flex;
    flex-direction: column;
  }
}
</style>
